import { Divider, Grid, Icon, Paper, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Col, Row, Select } from "antd";
import { LIST_CHAT_CHANNEL } from "constant";
import PropTypes from "prop-types";
import React, { Component } from "react";
import Chart from "react-google-charts";
import { connect } from "react-redux";

import datetimeHelper from "../../helper/datetime-helper";
import { globalHistory } from "../../history";
import { mapActionsToProps as GroupAction } from "../../redux/agent";
import { mapActionsToProps as Authenticaton } from "../../redux/authentication";
import { mapActionsToProps as NumberAction } from "../../redux/cloudPBX/phoneNumber";
import { mapActionsToProps } from "../../redux/dashboard";
import { mapActionsToProps as dashboardAction } from "../../redux/dashboard";
import { mapActionsToProps as MonitorReport } from "../../redux/miniCrm/monitor";
import { mapActionsToProps as TicketAction } from "../../redux/miniCrm/ticket";
import { mapActionsToProps as InboundReport } from "../../redux/report/inbound";
import { mapActionsToProps as OutboundReport } from "../../redux/report/outbound";
import { mapActionsToProps as RingmeChatActions } from "../../redux/ringme-ott-sdk";
import { getPercentage, roundToOne } from "../../ultis/commonFunctions";
import mainClasses from "./Dashboard.module.css";

let defaultReportChatByHour = [
  ["Thời gian", "Tổng số cuộc chat", "Tỷ lệ trả lời"],
];

for (let i = 7; i <= 21; i++) {
  defaultReportChatByHour.push([`${i}h`, 0, 0]);
}

let defaultColumnChartInboundData = [
  ["Thời gian", "Đã trả lời", "Nhỡ", "Từ chối", "Tỷ lệ trả lời"],
];

for (let i = 7; i <= 21; i++) {
  defaultColumnChartInboundData.push([`${i}h`, 0, 0, 0, 0]);
}

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      CaseNumber: "",
      number: "1900545481",
      contactCode: null,
      contactCenter: null,
      groupId: "",
      showDate: new Date(),
      chatChannel: null,
      sourcePage: null,
    };
  }

  componentDidMount() {
    const date =
      new URLSearchParams(this.props.location.search).get("date") || null;
    if (date) {
      this.setState({ showDate: new Date(date) });
    }
    const { subOrg = [], role } = this.props.userInfo || {};
    const contactWhere = {};
    if (subOrg.length) {
      // contactWhere['subOrgs'] = { inq: subOrg }
    }

    this.itemInit();
    this.getRingmeChatReportByHour();
    this.props.getListGroupAgent();
    this.props.dashboardContact(contactWhere);
    this.props.getListPhoneNumber();

    this.props.getListSourcePage();
    this.history = globalHistory();
    this.interval = setInterval(() => {
      this.itemInit();
    }, 5000);
    this.ringmeChatReportByHourInterval = setInterval(() => {
      this.getRingmeChatReportByHour();
    }, 9000);
    this.props.getTicketType();
    this.props.agentCallsRealtime(this.state.number, this.state.groupId);
    this.props.callsRealtime({
      number: this.state.number,
      groupId: this.state.groupId,
    });

    this.intervalCalls = setInterval(() => {
      return this.props.callsRealtime({
        number: this.state.number,
        groupId: this.state.groupId,
      });
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    clearInterval(this.agentCalls);
    clearInterval(this.intervalCalls);
    clearInterval(this.ringmeChatReportByHourInterval);
    window.removeEventListener("resize", this.onWindowResize);
  }

  componentWillReceiveProps(newProps) {
    if (newProps.contacts !== this.props.contacts) {
      this.props.getRingmeListChatQueueId({
        type: "CSKH",
        listChatDepartmentId: newProps.contacts.map(
          (item) => item.idDepartment
        ),
      });
    }
  }

  itemInit() {
    const { contactCode, contactCenter } = this.state;
    const { contacts } = this.props;
    this.props.getListTicket(
      "createdAt DESC",
      null,
      null,
      {
        where: {
          and: [
            {
              createdAt: {
                gte: `${datetimeHelper.toFormat(
                  this.state.showDate,
                  "YYYY-MM-DD startDay"
                )}`,
              },
            },
            {
              createdAt: {
                lte: `${datetimeHelper.toFormat(
                  this.state.showDate,
                  "YYYY-MM-DD endDay"
                )}`,
              },
            },
          ],
        },
      },
      "",
      contactCode
    );

    let filterSubOrg = [];
    if (contactCode && contacts.length) {
      const contact = contacts.find((item) => item.code == contactCode);
      if (contact && contact.subOrgs) {
        filterSubOrg = [...filterSubOrg, ...contact.subOrgs];
      }
    }

    this.props.agentCallsRealtime(
      this.state.number,
      this.state.groupId,
      filterSubOrg
    );
    // this.props.getListTicket("createdAt DESC",200,null, null, '')
    this.props.dashboardInbound(
      `${datetimeHelper.toFormat(this.state.showDate, "YYYY-MM-DD")}`,
      `${datetimeHelper.toFormat(this.state.showDate, "YYYY-MM-DD")}`,
      this.state.number,
      this.state.groupId,
      contactCode
    );
    this.props.dashboardOutbound(
      `${datetimeHelper.toFormat(this.state.showDate, "YYYY-MM-DD")}`,
      `${datetimeHelper.toFormat(this.state.showDate, "YYYY-MM-DD")}`,
      "",
      this.state.groupId,
      contactCode
    );
    this.props.getListReportInbound(
      `${datetimeHelper.toFormat(this.state.showDate, "YYYY-MM-DD")}`,
      `${datetimeHelper.toFormat(this.state.showDate, "YYYY-MM-DD")}`,
      this.state.number,
      this.state.groupId,
      contactCode
    );
    this.props.getListReportOutbound(
      `${datetimeHelper.toFormat(this.state.showDate, "YYYY-MM-DD")}`,
      `${datetimeHelper.toFormat(this.state.showDate, "YYYY-MM-DD")}`,
      "",
      this.state.groupId,
      contactCode
    );
    this.props.getAgentChatReport(
      contactCenter !== null
        ? {
            idDepartment: contactCenter.idDepartment,
            subOrgs: contactCenter.subOrgs,
          }
        : {
            idDepartment: this.props.contacts?.map((item) => item.idDepartment),
            subOrgs: this.props.contacts?.map((item) => item.subOrgs).flat(),
          }
    );
  }

  getRingmeChatReportByHour() {
    const { contactCenter } = this.state;
    this.props.getRingmeReportChatByHour({
      type: "CSKH",
      chatDepartmentId: contactCenter?.idDepartment,
      date: `${datetimeHelper.toFormat(this.state.showDate, "YYYY-MM-DD")}`,
      from_hour: 7,
      to_hour: 21,
    });
  }

  handleChange = (name) => {
    return (e) => {
      return this.setState({
        [name]: e.target.value,
      });
    };
  };

  handleSubmit = () => {
    this.itemInit();
    // this.props.agentCallsRealtime(this.state.number, this.state.groupId);
    this.props.callsRealtime({
      number: this.state.number,
      groupId: this.state.groupId,
    });
  };

  handleChangeSelectHead = (name, value) => {
    if (name === "contactCode") {
      this.props.getListPhoneNumber(null, null, null, null, value);
      this.setState({
        contactCenter: value
          ? this.props.contacts?.find((item) => item.code === value)
          : null,
      });

      if (value) {
        this.setState({ number: null });
      } else {
        this.setState({ number: "1900545481" });
      }
    }
    this.setState({ [name]: value }, () => {
      this.itemInit();
    });
  };

  shouldComponentUpdate(nextProps, nextState) {
    if (
      nextProps.contacts?.length == 1 &&
      nextProps.contacts[0].code !== this.state.contactCode
    ) {
      this.setState({ contactCode: nextProps.contacts[0].code });
    }
    return true;
  }

  render() {
    let {
      classes,
      inbound,
      outbound,
      agentCalls,
      calls,
      listPhoneNumber,
      inboundHours,
      contacts,
      agentChatReport,
      ringmeReportChatByHour,
    } = this.props;

    let chartInbound = [["Nội dung", "Số lượng"]];
    if (inbound && inbound.length && inbound[0]) {
      const totalInbound =
        inbound[0].answeredCalls +
        inbound[0].missedCalls +
        inbound[0].rejectedCalls;
      chartInbound.push(
        [
          `Cuộc gọi đã trả lời (${
            totalInbound
              ? roundToOne((inbound[0].answeredCalls * 100) / totalInbound)
              : 0
          }%)`,
          inbound[0].answeredCalls,
        ],
        [
          `Cuộc gọi nhỡ (${
            totalInbound
              ? roundToOne((inbound[0].missedCalls * 100) / totalInbound)
              : 0
          }%)`,
          inbound[0].missedCalls,
        ],
        [
          `Cuộc gọi từ chối (${
            totalInbound
              ? roundToOne((inbound[0].rejectedCalls * 100) / totalInbound)
              : 0
          }%)`,
          inbound[0].rejectedCalls,
        ]
      );
    }

    let chartOutbound = [["Nội dung", "Số lượng"]];
    if (outbound && outbound.length && outbound[0]) {
      const totalOutbound =
        outbound[0].answeredCalls +
        outbound[0].busyCalls +
        outbound[0].noAnsweredCalls;
      chartOutbound.push(
        [
          `Cuộc gọi đã trả lời (${
            totalOutbound
              ? roundToOne((outbound[0].answeredCalls * 100) / totalOutbound)
              : 0
          }%)`,
          outbound[0].answeredCalls,
        ],
        [
          `Cuộc gọi bận (${
            totalOutbound
              ? roundToOne((outbound[0].busyCalls * 100) / totalOutbound)
              : 0
          }%)`,
          outbound[0].busyCalls,
        ],
        [
          `Cuộc gọi không trả lời (${
            totalOutbound
              ? roundToOne((outbound[0].noAnsweredCalls * 100) / totalOutbound)
              : 0
          }%)`,
          outbound[0].noAnsweredCalls,
        ]
      );
    }
    let showItem = this.state.isMobile ? 6 : 3;
    let showItemCall = this.state.isMobile ? 12 : 6;

    let chartChat = [["Nội dung", "Số lượng"]];
    let chatData = [];
    if (chatData) {
      chartChat.push(
        ["Đã trả lời", agentChatReport?.doneThread || 0],
        ["Nhỡ", agentChatReport?.missedThread || 0]
      );
    }

    let reportChatByHour;

    if (ringmeReportChatByHour?.length > 0) {
      reportChatByHour = [["Thời gian", "Tổng số cuộc chat", "Tỷ lệ trả lời"]];
      ringmeReportChatByHour.forEach((item) => {
        reportChatByHour.push([
          `${item.hour}h`,
          item.report?.done_thread + item.report?.missed_thread,
          getPercentage(
            item.report?.done_thread,
            item.report?.done_thread + item.report?.missed_thread
          ) || 0,
        ]);
      });
    }

    return (
      <React.Fragment>
        <Paper
          className={classes.root}
          elevation={1}
          style={{ marginBottom: 12 }}>
          <div
            className={`${mainClasses.dashboard__multiSelectRoot} flexGridDashboard`}>
            <Row gutter={[16, 16]}>
              <Col xs={{ span: 12 }} lg={{ span: 8 }} xxl={{ span: 6 }}>
                <div className="antd-custom-select-container">
                  <span className="antd-custom-select-label">
                    Contact Center
                  </span>
                  <Select
                    showSearch
                    placeholder="Tất cả"
                    optionFilterProp="children"
                    value={this.state.contactCode}
                    className="antd-custom-select"
                    popupClassName="antd-custom-select-dropdown"
                    onChange={this.handleChangeSelectHead.bind(
                      this,
                      "contactCode"
                    )}
                    suffixIcon={<i className="fas fa-chevron-down"></i>}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={[
                      ...(contacts?.length == 1
                        ? []
                        : [{ value: null, label: "Tất cả" }]),
                      ...(contacts || []).map((d) => ({
                        value: d.code,
                        label: d.name,
                      })),
                    ]}
                  />
                </div>
              </Col>
              <Col xs={{ span: 12 }} lg={{ span: 5 }} xxl={{ span: 6 }}>
                <div className="antd-custom-select-container">
                  <span className="antd-custom-select-label">Kênh call</span>
                  <Select
                    showSearch
                    placeholder="Tất cả"
                    optionFilterProp="children"
                    value={this.state.number}
                    className="antd-custom-select"
                    popupClassName="antd-custom-select-dropdown"
                    onChange={this.handleChangeSelectHead.bind(this, "number")}
                    suffixIcon={<i className="fas fa-chevron-down"></i>}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={[
                      { value: null, label: "Tất cả" },
                      ...(listPhoneNumber || []).map((d) => ({
                        value: d.id,
                        label: d.id,
                      })),
                    ]}
                  />
                </div>
              </Col>
              <Col xs={{ span: 12 }} lg={{ span: 5 }} xxl={{ span: 6 }}>
                <div className="antd-custom-select-container">
                  <span className="antd-custom-select-label">Kênh chat</span>
                  <Select
                    showSearch
                    placeholder="Đang phát triển"
                    optionFilterProp="children"
                    value={this.state.chatChannel}
                    className="antd-custom-select"
                    popupClassName="antd-custom-select-dropdown"
                    suffixIcon={<i className="fas fa-chevron-down"></i>}
                    onChange={this.handleChangeSelectHead.bind(
                      this,
                      "chatChannel"
                    )}
                    options={[{ id: null, name: "Đang phát triển" }]
                      .concat(LIST_CHAT_CHANNEL)
                      .map((item) => ({
                        value: item.id,
                        label: item.name,
                      }))}
                  />
                </div>
              </Col>
              <Col xs={{ span: 12 }} lg={{ span: 6 }} xxl={{ span: 6 }}>
                <div className="antd-custom-select-container">
                  <span className="antd-custom-select-label">Nguồn trang</span>
                  <Select
                    showSearch
                    placeholder="Đang phát triển"
                    optionFilterProp="children"
                    value={this.state.sourcePage}
                    className="antd-custom-select"
                    popupClassName="antd-custom-select-dropdown"
                    suffixIcon={<i className="fas fa-chevron-down"></i>}
                    onChange={this.handleChangeSelectHead.bind(
                      this,
                      "sourcePage"
                    )}
                    options={[{ id: null, name: "Đang phát triển" }]
                      .concat([])
                      .map((item) => ({
                        value: item.id,
                        label: item.name,
                      }))}
                  />
                </div>
              </Col>
            </Row>
          </div>

          <Typography style={{ justifyContent: "center", display: "flex" }}>
            {datetimeHelper.toFormat(this.state.showDate, "YYYY-MM-DD")}
          </Typography>
          <Divider />

          <Divider />
          <Grid container>
            <Grid item md={6} style={{ borderRight: "1px solid #0000001f" }}>
              <Typography variant="h5" component="h3" style={{ padding: 10 }}>
                Inbound:{" "}
                {inbound != undefined
                  ? inbound[0]
                    ? inbound[0].answeredCalls +
                      inbound[0].missedCalls +
                      inbound[0].rejectedCalls +
                      inbound[0].ivrCalls
                    : 0
                  : 0}{" "}
                cuộc
              </Typography>
              <Divider />
              <Grid container style={{ padding: 10 }}>
                <Grid item md className={classes.grid}>
                  <Icon
                    style={{ marginRight: 15, fontSize: 30, color: "#000" }}>
                    how_to_reg
                  </Icon>
                  <div>
                    <Typography>Trực tuyến</Typography>
                    <Typography gutterBottom variant="title">
                      {agentCalls["agentAvailable"] != undefined
                        ? agentCalls["agentAvailable"].length
                        : 0}
                    </Typography>
                  </div>
                </Grid>
                <Grid item md className={classes.grid}>
                  <Icon
                    style={{ marginRight: 15, fontSize: 30, color: "#43a047" }}>
                    people_outline
                  </Icon>
                  <div>
                    <Typography>Sẵn sàng</Typography>
                    <Typography gutterBottom variant="title">
                      {agentCalls["agentReady"] != undefined
                        ? agentCalls["agentReady"].length
                        : 0}
                    </Typography>
                  </div>
                </Grid>
                <Grid item md className={classes.grid}>
                  <Icon
                    style={{ marginRight: 15, fontSize: 30, color: "#015290" }}>
                    phone_callback
                  </Icon>
                  <div>
                    <Typography>Đang nhận cuộc gọi</Typography>
                    <Typography gutterBottom variant="title">
                      {agentCalls["agentCallInbound"] != undefined
                        ? agentCalls["agentCallInbound"].length
                        : 0}
                    </Typography>
                  </div>
                </Grid>
                <Grid item md className={classes.grid}>
                  <Icon
                    style={{ marginRight: 15, fontSize: 30, color: "#015290" }}>
                    record_voice_over
                  </Icon>
                  <div>
                    <Typography>Đang tạm nghỉ</Typography>
                    <Typography gutterBottom variant="title">
                      {agentCalls["pause"] != undefined
                        ? agentCalls["pause"].length
                        : 0}
                    </Typography>
                  </div>
                </Grid>
              </Grid>
              <Divider />
              <Grid container style={{ padding: 10 }}>
                <Grid
                  item
                  xl={6}
                  md={4}
                  xs={12}
                  style={{ padding: 10 }}
                  className={classes.grid}>
                  <Grid container>
                    <Grid item xl={6} xs={12} className={classes.grid}>
                      <Icon
                        style={{
                          marginRight: 15,
                          fontSize: 30,
                          color: "#000",
                        }}>
                        ring_volume
                      </Icon>
                      <div>
                        <Typography>Đang vào IVR</Typography>
                        <Typography
                          style={{ display: "flex", alignItems: "center" }}>
                          <Typography
                            variant="title"
                            style={{ marginLeft: 5, marginRight: 5 }}>
                            {this.props.calls != undefined
                              ? calls.inboundCalls
                                ? this.props.calls.inboundCalls.filter(
                                    (call) => call.status === "ivr"
                                  ) !== undefined
                                  ? this.props.calls.inboundCalls.filter(
                                      (call) => call.status === "ivr"
                                    ).length
                                  : 0
                                : 0
                              : 0}
                          </Typography>
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xl={6} xs={12} className={classes.grid}>
                      <Icon
                        style={{
                          marginRight: 15,
                          fontSize: 30,
                          color: "#000",
                        }}>
                        phone_callback
                      </Icon>
                      <div>
                        <Typography>Đang chờ trong hàng đợi</Typography>
                        <Typography
                          style={{ display: "flex", alignItems: "center" }}>
                          <Typography
                            variant="title"
                            style={{ marginLeft: 5, marginRight: 5 }}>
                            {
                              // this.props.calls != undefined ?
                              //     calls.inboundCalls ?
                              //         this.props.calls.inboundCalls.filter(call => call.status === "queuing") !== undefined ?
                              //             this.props.calls.inboundCalls.filter(call => call.status === "queuing").length + calls.outboundCalls.filter(call => call.status == "ringing") !== undefined ? calls.outboundCalls.filter(call => call.status == "ringing").length : 0
                              //             : 0 + calls.outboundCalls.filter(call => call.status == "ringing").length : 0 : 0}</Typography>
                              this.props.calls != undefined
                                ? calls.inboundCalls
                                  ? this.props.calls.inboundCalls.filter(
                                      (call) =>
                                        call.status === "queuing" ||
                                        call.status == "ringing"
                                    ) !== undefined
                                    ? this.props.calls.inboundCalls.filter(
                                        (call) =>
                                          call.status === "queuing" ||
                                          call.status == "ringing"
                                      ).length
                                    : 0
                                  : 0
                                : 0
                            }
                          </Typography>
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xl={6} xs={12} className={classes.grid}>
                      <Icon
                        style={{
                          marginRight: 15,
                          fontSize: 30,
                          color: "#fcb71e",
                        }}>
                        phone_missedCalls
                      </Icon>
                      <div style={{ textAlign: "center" }}>
                        <Typography>Nhỡ</Typography>
                        <Typography
                          gutterBottom
                          style={{ alignItems: "center", display: "flex" }}>
                          <Typography variant="title" style={{ marginLeft: 5 }}>
                            {inbound != undefined
                              ? inbound[0]
                                ? inbound[0].missedCalls
                                : 0
                              : 0}
                          </Typography>
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xl={6} xs={12} className={classes.grid}>
                      <Icon
                        style={{
                          marginRight: 15,
                          fontSize: 30,
                          color: "#015290",
                        }}>
                        phone_in_talk
                      </Icon>
                      <div style={{ textAlign: "center" }}>
                        <Typography>Đã trả lời</Typography>
                        <Typography
                          gutterBottom
                          style={{ alignItems: "center", display: "flex" }}>
                          <Typography variant="title" style={{ marginLeft: 5 }}>
                            {inbound != undefined
                              ? inbound[0]
                                ? inbound[0].answeredCalls
                                : 0
                              : 0}
                          </Typography>
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xl={6} xs={12} className={classes.grid}>
                      <Icon
                        style={{
                          marginRight: 15,
                          fontSize: 30,
                          color: "#43a047",
                        }}>
                        phone_locked
                      </Icon>
                      <div style={{ textAlign: "center" }}>
                        <Typography>Nhỡ IVR</Typography>
                        <Typography
                          gutterBottom
                          style={{ alignItems: "center", display: "flex" }}>
                          <Typography variant="title" style={{ marginLeft: 5 }}>
                            {inbound != undefined
                              ? inbound[0]
                                ? inbound[0].ivrCalls
                                : 0
                              : 0}
                          </Typography>
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xl={6} xs={12} className={classes.grid}>
                      <Icon
                        style={{ marginRight: 15, fontSize: 30, color: "red" }}>
                        phone_paused
                      </Icon>
                      <div style={{ textAlign: "center" }}>
                        <Typography>Từ chối</Typography>
                        <Typography
                          gutterBottom
                          style={{ alignItems: "center", display: "flex" }}>
                          <Typography variant="title" style={{ marginLeft: 5 }}>
                            {inbound != undefined
                              ? inbound[0]
                                ? inbound[0].rejectedCalls
                                : 0
                              : 0}
                          </Typography>
                        </Typography>
                      </div>
                    </Grid>

                    <Grid item xl={6} xs={12} className={classes.grid}>
                      <Icon
                        style={{
                          marginRight: 15,
                          fontSize: 30,
                          color: "#000",
                        }}>
                        phone
                      </Icon>
                      <div>
                        <Typography>Thời gian thoại tb</Typography>
                        <Typography
                          gutterBottom
                          style={{ alignItems: "center", display: "flex" }}>
                          <Typography variant="title" style={{ marginLeft: 5 }}>
                            {inbound != undefined
                              ? inbound[0]
                                ? inbound[0].acd != null
                                  ? datetimeHelper.secondToHHMMSS(
                                      inbound[0].acd
                                    )
                                  : "00:00:00"
                                : 0
                              : 0}
                          </Typography>
                        </Typography>
                      </div>
                    </Grid>

                    <Grid item xl={6} xs={12} className={classes.grid}>
                      <Icon
                        style={{
                          marginRight: 15,
                          fontSize: 30,
                          color: "#000",
                        }}>
                        timer_sharp
                      </Icon>
                      <div>
                        <Typography>Thời gian chờ tb</Typography>
                        <Typography
                          gutterBottom
                          style={{ alignItems: "center", display: "flex" }}>
                          <Typography variant="title" style={{ marginLeft: 5 }}>
                            {inbound != undefined
                              ? inbound[0]
                                ? inbound[0].avgWaitCall != null
                                  ? datetimeHelper.secondToHHMMSS(
                                      inbound[0].avgWaitCall
                                    )
                                  : "00:00:00"
                                : 0
                              : 0}
                          </Typography>
                        </Typography>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xl={6} md={8} xs={12} className={classes.grid}>
                  <Chart
                    width={"100%"}
                    // height={'300px'}
                    chartType="PieChart"
                    loader={<div>Loading Chart</div>}
                    data={chartInbound}
                    options={{
                      colors: ["#015290", "#fcb71e", "gray"],
                      title: "Cuộc gọi trả lời - nhỡ - từ chối",
                      sliceVisibilityThreshold: 0,
                      // chartArea:{
                      // width: 450,
                      // height: 300
                      // }
                      // width: this.state.isMobile ? 430 : '100%',
                      height: 330,
                    }}
                    rootProps={{ "data-testid": "1" }}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={6}>
              <Typography variant="h5" component="h3" style={{ padding: 10 }}>
                Chat:{" "}
                {(agentChatReport?.doneThread || 0) +
                  (agentChatReport?.missedThread || 0)}{" "}
                cuộc
              </Typography>
              <Divider />
              <Grid container style={{ padding: 10 }}>
                <Grid item md className={classes.grid}>
                  <Icon
                    style={{ marginRight: 15, fontSize: 30, color: "#000" }}>
                    how_to_reg
                  </Icon>
                  <div>
                    <Typography>Trực tuyến</Typography>
                    <Typography gutterBottom variant="title">
                      {agentChatReport?.agentOnline || 0}
                    </Typography>
                  </div>
                </Grid>
                <Grid item md className={classes.grid}>
                  <Icon
                    style={{ marginRight: 15, fontSize: 30, color: "#43a047" }}>
                    person_outline
                  </Icon>
                  <div>
                    <Typography>Sẵn sàng</Typography>
                    <Typography gutterBottom variant="title">
                      {agentChatReport?.agentReadyChat || 0}
                    </Typography>
                  </div>
                </Grid>
                <Grid item md className={classes.grid}>
                  <Icon
                    style={{ marginRight: 15, fontSize: 30, color: "#1e77d7" }}>
                    person_outline
                  </Icon>
                  <div>
                    <Typography>Đang nhận chat</Typography>
                    <Typography gutterBottom variant="title">
                      {agentChatReport?.agentChatting || 0}
                    </Typography>
                  </div>
                </Grid>
                <Grid item md className={classes.grid}>
                  <Icon
                    style={{ marginRight: 15, fontSize: 30, color: "#F6A63F" }}>
                    person_outline
                  </Icon>
                  <div>
                    <Typography>Ăn ca</Typography>
                    <Typography gutterBottom variant="title">
                      {agentChatReport?.agentEatting || 0}
                    </Typography>
                  </div>
                </Grid>
                <Grid item md className={classes.grid}>
                  <Icon
                    style={{ marginRight: 15, fontSize: 30, color: "#E3475A" }}>
                    person_outline
                  </Icon>
                  <div>
                    <Typography>Tạm nghỉ</Typography>
                    <Typography gutterBottom variant="title">
                      {agentChatReport?.agentPause || 0}
                    </Typography>
                  </div>
                </Grid>
                <Grid item md className={classes.grid}>
                  <Icon
                    style={{ marginRight: 15, fontSize: 30, color: "#413DC2" }}>
                    person_outline
                  </Icon>
                  <div>
                    <Typography>Bận</Typography>
                    <Typography gutterBottom variant="title">
                      {agentChatReport?.agentBusy || 0}
                    </Typography>
                  </div>
                </Grid>
              </Grid>
              <Divider />
              <Grid container style={{ padding: 10 }}>
                <Grid
                  item
                  xl={6}
                  md={4}
                  xs={12}
                  style={{ padding: 10 }}
                  className={classes.grid}>
                  <Grid container>
                    <Grid item xl={6} xs={12} className={classes.grid}>
                      <Icon
                        style={{
                          marginRight: 15,
                          fontSize: 30,
                          color: "#FF3D00",
                        }}>
                        chat
                      </Icon>
                      <div>
                        <Typography>Đang chờ</Typography>
                        <Typography
                          gutterBottom
                          style={{ alignItems: "center", display: "flex" }}>
                          <Typography
                            variant="title"
                            style={{ marginRight: 5, marginLeft: 5 }}>
                            {agentChatReport?.waitingThread || 0}
                          </Typography>
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xl={6} xs={12} className={classes.grid}>
                      <Icon
                        style={{
                          marginRight: 15,
                          fontSize: 30,
                          color: "#FCB71E",
                        }}>
                        chat
                      </Icon>
                      <div>
                        <Typography>Hiệu suất</Typography>
                        <Typography
                          gutterBottom
                          style={{ alignItems: "center", display: "flex" }}>
                          <Typography variant="title" style={{ marginLeft: 5 }}>
                            {agentChatReport?.agentPerformance || "0/0"}
                          </Typography>
                        </Typography>
                      </div>
                    </Grid>

                    <Grid item xl={6} xs={12} className={classes.grid}>
                      <Icon
                        style={{
                          marginRight: 15,
                          fontSize: 30,
                          color: "#008000",
                        }}>
                        question_answers
                      </Icon>
                      <div>
                        <Typography>Đang trả lời</Typography>
                        <Typography
                          gutterBottom
                          style={{ alignItems: "center", display: "flex" }}>
                          <Typography variant="title" style={{ marginLeft: 5 }}>
                            {agentChatReport?.processingThread || 0}
                          </Typography>
                        </Typography>
                      </div>
                    </Grid>

                    <Grid item xl={6} xs={12} className={classes.grid}>
                      <Icon
                        style={{
                          marginRight: 15,
                          fontSize: 30,
                          color: "#A5A5A5",
                        }}>
                        question_answers
                      </Icon>
                      <div>
                        <Typography>Số cuộc chat nhỡ</Typography>
                        <Typography
                          gutterBottom
                          style={{ alignItems: "center", display: "flex" }}>
                          <Typography variant="title" style={{ marginLeft: 5 }}>
                            {agentChatReport?.missedThread || 0}
                          </Typography>
                        </Typography>
                      </div>
                    </Grid>

                    <Grid item xl={6} xs={12} className={classes.grid}>
                      <Icon
                        style={{
                          marginRight: 15,
                          fontSize: 30,
                          color: "#015290",
                        }}>
                        chat
                      </Icon>
                      <div>
                        <Typography>Đã trả lời</Typography>
                        <Typography
                          gutterBottom
                          style={{ alignItems: "center", display: "flex" }}>
                          <Typography
                            variant="title"
                            style={{ marginLeft: 5, color: "#000" }}>
                            {agentChatReport?.doneThread || 0}
                          </Typography>
                        </Typography>
                      </div>
                    </Grid>

                    <Grid item xl={6} xs={12} className={classes.grid}>
                      <Icon
                        style={{
                          marginRight: 15,
                          fontSize: 30,
                          color: "#000",
                        }}>
                        chat
                      </Icon>
                      <div>
                        <Typography>{"Chat > 5 phút"}</Typography>
                        <Typography
                          gutterBottom
                          style={{ alignItems: "center", display: "flex" }}>
                          <Typography variant="title" style={{ marginLeft: 5 }}>
                            {agentChatReport?.chat5MinThread || 0}
                          </Typography>
                        </Typography>
                      </div>
                    </Grid>

                    <Grid item xl={6} xs={12} className={classes.grid}>
                      <Icon
                        style={{
                          marginRight: 15,
                          fontSize: 30,
                          color: "#000",
                        }}>
                        question_answers
                      </Icon>
                      <div>
                        <Typography>Thời gian chat tb</Typography>
                        <Typography
                          gutterBottom
                          style={{ alignItems: "center", display: "flex" }}>
                          <Typography variant="title" style={{ marginLeft: 5 }}>
                            {agentChatReport?.doneTimeAvg
                              ? datetimeHelper.secondToHHMMSS(
                                  agentChatReport.doneTimeAvg
                                )
                              : "00:00:00"}
                          </Typography>
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xl={6} xs={12} className={classes.grid}>
                      <Icon
                        style={{
                          marginRight: 15,
                          fontSize: 30,
                          color: "#000",
                        }}>
                        timer_sharp
                      </Icon>
                      <div>
                        <Typography>Thời gian chờ tb</Typography>
                        <Typography
                          gutterBottom
                          style={{ alignItems: "center", display: "flex" }}>
                          <Typography variant="title" style={{ marginLeft: 5 }}>
                            {agentChatReport?.waitingTimeAvg
                              ? datetimeHelper.secondToHHMMSS(
                                  agentChatReport.waitingTimeAvg
                                )
                              : "00:00:00"}
                          </Typography>
                        </Typography>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xl={6} md={8} xs={12} className={classes.grid}>
                  <Chart
                    width={"100%"}
                    chartType="PieChart"
                    loader={<div>Loading Chart</div>}
                    data={chartChat}
                    options={{
                      colors: ["#015290", "#fcb71e"],
                      title: "Cuộc chat đã trả lời - nhỡ",
                      sliceVisibilityThreshold: 0,
                      height: 330,
                    }}
                    rootProps={{ "data-testid": "1" }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
        <Grid container>
          <Grid item xs={12} md={6}>
            <div className="chart-container">
              <div className="chart-title">
                Lưu lượng cuộc call theo khung giờ -{" "}
                {datetimeHelper.toFormat(this.state.showDate, "YYYY-MM-DD")}
              </div>
              <Chart
                width={"100%"}
                height={"300px"}
                chartType="ComboChart"
                data={
                  (inboundHours?.[0]?.calls !== 0 &&
                    inboundHours?.reportChart) ||
                  defaultColumnChartInboundData
                }
                options={{
                  seriesType: "bars",
                  isStacked: true,
                  legend: {
                    position: "bottom",
                  },
                  series: {
                    3: {
                      type: "line",
                      lineWidth: 4,
                      targetAxisIndex: 1,
                    },
                  },
                  colors: ["#4C73C7", "#E57C25", "#AFAFAF", "#F3C62F"],
                  vAxis: {
                    minValue: 100,
                  },
                  vAxes: {
                    1: { title: "" },
                  },
                }}
                // For tests
                rootProps={{ "data-testid": "3" }}
              />
            </div>
          </Grid>

          <Grid item xs={12} md={6} style={{ padding: 1 }}>
            <div className="chart-container">
              <div className="chart-title">
                Lưu lượng cuộc chat theo khung giờ -{" "}
                {datetimeHelper.toFormat(this.state.showDate, "YYYY-MM-DD")}
              </div>
              <Chart
                width={"100%"}
                height={"300px"}
                chartType="ComboChart"
                data={reportChatByHour || defaultReportChatByHour}
                options={{
                  seriesType: "bars",
                  isStacked: true,
                  legend: {
                    position: "bottom",
                  },
                  series: {
                    1: {
                      type: "line",
                      lineWidth: 4,
                      targetAxisIndex: 1,
                    },
                  },
                  colors: ["#4C73C7", "#F3C62F"],
                  vAxis: {
                    maxValue: 8,
                  },
                  vAxes: {
                    1: {
                      title: "",
                      viewWindowMode: "explicit",
                      viewWindow: {
                        max: 100,
                        min: 0,
                      },
                    },
                  },
                }}
              />
            </div>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

const styles = (theme) => ({
  form: {
    width: "100%",
  },
  title: {
    marginBottom: 20,
    color: "#000",
  },
  grid: {
    alignItems: "center",
    display: "flex",
  },
  input: {
    width: "100%",
  },
  textField: {
    width: 200,
  },
});

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  userInfo: state.auth?.init?.profile?.user,
  listTicketType: state.ticket.ticketType,
  outbound: state.reportOutbound.report,
  inbound: state.reportInbound.report,
  agentCalls: state.monitor.agentCalls,
  calls: state.monitor.calls,
  listPhoneNumber: state.phoneNumber.phoneNumbers,
  inboundHours: state.dashboard.inbound,
  contacts: state.dashboard.contact,
  listSourcePage: state.dashboard.listSourcePage,
  agentChatReport: state.dashboard.agentChatReport,
  ringmeReportChatByHour: state.ringmeOttSdk.ringmeReportChatByHour,
});

Dashboard = connect(mapStateToProps, mapActionsToProps)(Dashboard);
const Ticket = connect(null, TicketAction)(Dashboard);
const Outbound = connect(null, OutboundReport)(Ticket);
const Inbound = connect(null, InboundReport)(Outbound);
const Monitor = connect(null, MonitorReport)(Inbound);
const NumberConnect = connect(null, NumberAction)(Monitor);
const Group = connect(null, GroupAction)(NumberConnect);
const RingmeChat = connect(null, RingmeChatActions)(Group);
const Auth = connect(null, Authenticaton)(RingmeChat);
const dashboard = connect(null, dashboardAction)(Auth);

export default withStyles(styles)(dashboard);
